import FileSaver from 'file-saver';

/**
 * 从Content-disposition中提取文件名
 * @param disposition
 * @returns {string}
 */
function extractDispositionName(disposition) {
    //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
    const pattern = new RegExp('filename=([^;]+\\.[^\\.;]+);*');
    const result = pattern.exec(disposition);
    return decodeURI(decodeURIComponent(escape(result[1])));
}

/**
 * js 作为代理从远程获取文件内容然后下载文件
 * @param response
 */
function jsDownload(response, self) {
    let reader = new FileReader(); // 创建读取文件对象
    try {
        reader.readAsText(response.data, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
        reader.addEventListener('loadend', () => {
            try {
                let res = JSON.parse(reader.result); // 返回的数据
                if (res.message) return self.$message({ showClose: true, message: res.message, type: 'error' });
            } catch (error) {
                let blob = new Blob([response.data], {type: response.headers['content-type']});
                const filename = extractDispositionName(response.headers['content-disposition']);
                FileSaver.saveAs(blob, filename);
            }
        });
    } catch (error) {
        let blob = new Blob([response.data], {type: response.headers['content-type']});
        const filename = extractDispositionName(response.headers['content-disposition']);
        FileSaver.saveAs(blob, filename);
    }
}

function jsDownloadDecodeURI(response) {

    let blob = new Blob([response.data], {type: response.headers['content-type']});
    const filename = extractDispositionName(response.headers['content-disposition']);

    const pattern = new RegExp('filename=([^;]+\\.[^\\.;]+);*');
    const result = pattern.exec(response.headers['content-disposition']);
    FileSaver.saveAs(blob, decodeURI(result[1]));
}
function downloadMappingUrl(body, _self) {
    _self.$http.post(WebApi.codesManage.download, body).then(response => {
        _self.$emit('closeDialog');
        if (response.data && response.data.success) {
            const ele = document.createElement('a');
            ele.setAttribute('href', response.data.data); //设置下载文件的url地址
            ele.setAttribute('target', '_blank');//用于设置下载文件的文件名
            ele.click();
            return;
        }
        _self.$message({
            showClose: true,
            message: _self.$STR(response.data.resultCode, response.data.message),
            type: 'error'
        });
    });
}

//下载txt
function jsDownLoadTxt(url) {
    let link = document.createElement('a');
    // 这里是将url转成blob地址，
    fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        link.href = URL.createObjectURL(blob);
        link.download = '';
        document.body.appendChild(link);
        link.click();
    });
}

export {extractDispositionName, jsDownload, jsDownloadDecodeURI, downloadMappingUrl, jsDownLoadTxt};



// WEBPACK FOOTER //
// ./src/common/utils/downloader.js